import { Profile } from '@/types'
import { AuthErrors } from './errors'
import { isEmailAvailable } from './views'
import { firebase } from '@/services/firebase'
import { appStatusStore } from '@/stores'
import { ReactQuery } from '@codeleap/query'
import { useProfile } from './useProfile'
import { QueryKeys } from './queryKeys'
import { update } from './views'

export function useEdit() {
  const { profile } = useProfile()

  const updateProfile = ReactQuery.useMutation({
    mutationKey: QueryKeys.create.key,
    mutationFn: update,
    onSuccess: () => {
      QueryKeys.me.refresh()
    },
  })

  const editProfile = async (data: Partial<Profile>) => {
    appStatusStore.set('loading')

    try {
      const emailAddressChanged = data?.email?.trim() !== profile?.email?.trim()

      if (emailAddressChanged) {
        const emailAvailable = await isEmailAvailable(data.email)

        if (!emailAvailable) {
          AuthErrors.exception('auth/email-in-use')
        }

        try {
          await firebase.auth.updateEmail(firebase.auth.currentUser, data.email)
        } catch (e) {
          AuthErrors.exception(e?.code)
        }
      }

      const response = await updateProfile.mutateAsync(data)

      appStatusStore.set('done')

      return response
    } catch (err) {
      appStatusStore.set('idle')
      AuthErrors.onError(err)
      throw err
    }
  }

  return {
    profile,
    editProfile,
    updateProfile
  }
}